import { useState } from 'react';
import { useSelector } from 'react-redux';
import { DsVersionRef } from 'dragonmouse-shared/interfaces';
import Modal from 'components/Modal';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';

interface VersionHistoryModalProps {
	onSelectVersion: (versionNumber: number) => void;
	onDuplicate: (versionNumber: number) => void;
	onClose: () => void;
}

const formatDate = (date: Date) => {
	return date.toLocaleDateString(undefined, {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	});
};

const VersionHistoryModal = ({
	onSelectVersion,
	onDuplicate,
	onClose,
}: VersionHistoryModalProps) => {
	const dsVersionRefs = useSelector((r: RootReducer) => r.db.dsVersionRefs);
	const [selected, setSelected] = useState<number | null>(null);

	return (
		<Modal
			title="Version History"
			onClose={onClose}
			onCancel={onClose}
			cancelLabel="Cancel"
			submitLabel="Load"
			onSubmit={() => selected !== null && onSelectVersion(selected)}
			disabled={selected === null}
		>
			<S.List>
				{dsVersionRefs.map((v: DsVersionRef) => (
					<S.VersionRow
						key={v.versionNumber}
						$selected={selected === v.versionNumber}
						onClick={() => setSelected(v.versionNumber)}
					>
						<S.VersionLabel>v{v.versionNumber}</S.VersionLabel>
						<S.RowRight>
							{/*
							while it was quite cool to be able to duplicate from here
							the UI distracts from the main purpose of the modal
							so commenting it out for now - ss
							<S.DuplicateLink
								onClick={(e) => {
									e.stopPropagation();
									onDuplicate(v.versionNumber);
								}}
							>
								Duplicate
							</S.DuplicateLink> */}
							<S.VersionDate>{formatDate(v.createdAt)}</S.VersionDate>
						</S.RowRight>
					</S.VersionRow>
				))}
			</S.List>
		</Modal>
	);
};

export default VersionHistoryModal;
